import React, { useContext } from 'react';

import { PageContext } from '../../context/PageContext';
import { Links } from '../../utils/constants';
import { CustomLink } from '../CustomMDXRenderer/CustomLink';

import * as classes from './style.module.scss';

interface Props {
  version?: string;
  changelogURL?: string;
}

export const Introduced: React.FC<Props> = ({ version, changelogURL }) => {
  const { product } = useContext(PageContext);

  return (
    <div className={classes.root}>
      <span className={classes.emoji}>✨</span>
      {changelogURL ? (
        <CustomLink href={changelogURL}>Introduced</CustomLink>
      ) : (
        'Introduced'
      )}
      {' in '}
      {`${
        Links.DocsMenuItems.find(({ id }) => id === product)?.name || product
      } v${version} `}
    </div>
  );
};
